export default __webpack_public_path__ + "static/media/riaz2.92efed79.jpg";